import React from 'react'
import { graphql } from 'react-apollo'
import { withApollo } from 'react-apollo'
import { inject, observer } from 'mobx-react'
import PropTypes from 'prop-types'
import { withStyles } from 'material-ui/styles'
import { Paper, Modal, Typography, LinearProgress } from 'material-ui'
import ChevronLeftIcon from 'material-ui-icons/ChevronLeft'
import Button from 'material-ui/Button'
import IconButton from 'material-ui/IconButton'
import ImportContactsIcon from 'material-ui-icons/ImportContacts'
import BookIcon from 'material-ui-icons/Book'
import CheckIcon from 'material-ui-icons/Check'
import AddIcon from 'material-ui-icons/Add'
import EditIcon from 'material-ui-icons/Edit'
import ClearIcon from 'material-ui-icons/Clear'
import DescriptionIcon from 'material-ui-icons/Description'
import { GC_USER_ID, GC_AUTH_TOKEN, ALABASTER, BOULDER } from '@/constants'
import GridList, { GridListTile } from 'material-ui/GridList'
import List, { ListItem, ListItemText, ListItemIcon } from 'material-ui/List'
import TextField from 'material-ui/TextField'
import * as moment from 'moment'

import {
  READ_DATASETNAMEDES,
  READ_DATASETNAME,
  READ_DATASETS
} from '@/graphql/queries/dataset'
import { CREATE_DATASET, UPDATE_DATASET } from '@/graphql/mutations/dataset'

const styles = theme => ({
  root: {
    width: '100%'
  },
  divText: {
    display: 'flex',
    justifyContent: 'center',
    textAlign: 'center',
    paddingTop: 10,
    width: '100%'
  },
  linearColorPrimary: {},
  linearBarColorPrimary: {
    backgroundColor: 'rgba(80, 227, 194, .4)'
  },
  linearBarColorPrimaryComplete: {
    backgroundColor: 'rgba(144,238,144, .5)'
  },
  textFilter: {
    color: 'lightgrey',
    fontSize: 14,
    width: 340,
    fontWeight: 100,
    cursor: 'pointer'
  },
  textFilterGery: {
    color: 'grey',
    fontSize: 14,
    width: 340,
    fontWeight: 100,
    cursor: 'pointer'
  },
  activeSection: {
    backgroundColor: 'white',
    padding: 30
  },
  diableSection: {
    backgroundColor: '#f8f8f8',
    padding: 50
  },
  addSection: {
    backgroundColor: ALABASTER,
    padding: 25
  },
  iconBook: {
    color: 'rgba(0, 0, 0, .1)',
    width: 60,
    height: 60
  },
  iconBookAdd: {
    color: 'rgba(0, 0, 0, .1)',
    width: 60,
    height: 60,
    paddingTop: 15
  },
  gridList: {
    width: '100%'
  },
  gridSubtitle: {
    color: BOULDER,
    lineHeight: 2
  },
  bookBlock: {
    position: 'relative',
    textAlign: 'center',
    width: 93
  },
  paperBlock: {
    margin: theme.spacing.unit * 1,
    boxShadow: '0px 0px 10px #dddddd',
    backgroundColor: 'rgba(222,184,135, .1)',
    height: 120,
    width: 93,
    cursor: 'pointer'
  },
  progressBar: {
    marginTop: -theme.spacing.unit * 3,
    marginLeft: theme.spacing.unit * 1,
    marginRight: theme.spacing.unit * 1
  },
  paperBlockAdd: {
    margin: theme.spacing.unit * 1,
    boxShadow: '0px 0px 10px #dddddd',
    backgroundColor: 'white',
    height: 120,
    width: 93,
    cursor: 'pointer'
  },
  paperBlockAddNoCursor: {
    margin: theme.spacing.unit * 1,
    boxShadow: '0px 0px 10px #dddddd',
    backgroundColor: 'white',
    height: 120,
    width: 93
  },
  icon: {
    backgroundColor: 'white',
    boxShadow: '0px 0px 10px #eeeeee',
    margin: theme.spacing.unit
  },
  rootBottom: {
    height: 100,
    backgroundColor: ALABASTER,
    textAlign: 'left'
  },
  divAddModalButton: {
    textAlign: 'right',
    paddingRight: theme.spacing.unit * 1
  },
  iconBtnCheckAdd: {
    backgroundColor: 'white',
    boxShadow: '0px 0px 10px #eeeeee',
    marginBottom: theme.spacing.unit * 2,
    marginRight: theme.spacing.unit,
    width: 24,
    height: 24
  },
  iconBtnCheck: {
    backgroundColor: 'white',
    boxShadow: '0px 0px 10px #eeeeee',
    margin: theme.spacing.unit
  },
  iconEdit: {
    color: 'rgba(0, 0, 0, .1)',
    fontSize: 14
  },
  modalAddToday: {
    display: 'inline-block',
    overflow: 'scroll'
  },
  paperAddTodayMoreInfo: {
    boxShadow: '0px 0px 10px #eeeeee',
    width: '90%',
    marginLeft: '5%',
    marginTop: window.innerHeight * 0.05
  },
  divAddTpday: {
    position: 'relative',
    alignItems: 'center',
    width: '100%'
  },
  divClearButton: {
    textAlign: 'right',
    height: 26
  },
  iconClear: {
    color: 'rgba(0, 0, 0, .2)',
    fontSize: 26
  },
  modalContentDone: {
    height: 50,
    width: '100%',
    textAlign: 'left',
    backgroundColor: ALABASTER
  }
})

@withApollo
@inject('resultBooks')
@inject('resultBookPref')
@observer
@graphql(CREATE_DATASET, { name: 'createDataSet' })
@graphql(UPDATE_DATASET, { name: 'UpdateDataSet' })
@graphql(READ_DATASETNAMEDES, {
  name: 'readBooksDefault',
  options: ({ match }) => ({
    variables: {
      dataName: 'defaultBooks',
      dataDescription: 'defaultBooks'
    }
  })
})
@graphql(READ_DATASETNAME, {
  name: 'readUserBookPreference',
  options: ({ match }) => ({
    variables: {
      dataName: 'defaultUserBookPreference',
      userId: global.localStorage.getItem(GC_USER_ID)
    }
  })
})
@graphql(READ_DATASETS)
@withStyles(styles)
export default class AlchemyBooks extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      bookTypeSelected: 'To Read',
      open: false,
      isEdit: false
    }
    this.handleAddBook = this.handleAddBook.bind(this)
    this.handleChange = this.handleChange.bind(this)
    this.chooseBook = this.chooseBook.bind(this)
  }

  handleFilterChange = filter => {
    this.setState({ bookTypeSelected: filter })
  }

  chooseBook = book => {
    //('selected book: ' + book.bookName)
    var allBookPref = []
    const bookSelected = {
      id: book.id,
      bookName: book.bookName,
      bookAuthor: book.bookAuthor,
      totalPages: book.totalPages,
      isCurrent: '1',
      maxPage: 0,
      percentRead: 0
    }

    if (this.props.readUserBookPreference.loading) {
      return <div>Loading user book preference data ... </div>
    }

    if (this.props.resultBookPref.books.length === 0) {
      if (this.props.readUserBookPreference.allDataSets.length === 1) {
        if (
          this.props.readUserBookPreference.allDataSets[0].dataPoints !== ''
        ) {
          //('compare if seleted book exists')
          allBookPref = JSON.parse(
            this.props.readUserBookPreference.allDataSets[0].dataPoints
          )
          const bookSelectedBefore = allBookPref.filter(b => b.id === book.id)
          if (bookSelectedBefore.length === 0) {
            //('book is not selected before')
            //remove current from previous current
            const bookPrevCurrent = allBookPref.filter(
              bo => bo.isCurrent === '1'
            )
            if (bookPrevCurrent.length === 1) {
              //('reset isCurrent')
              allBookPref[allBookPref.indexOf(bookPrevCurrent[0])][
                'isCurrent'
              ] =
                '0'
            }
            //add new book as current
            allBookPref.splice(0, 0, bookSelected)
            this.props.resultBookPref.updateBooks(allBookPref)
            this.props.resultBookPref.updateBook(bookSelected)
            this.updateDataPointsUserBookPref(JSON.stringify(allBookPref))
          } else if (bookSelectedBefore.length === 1) {
            //('book is selected before')
          } else {
            return <div>error: book is duplicated, contact support</div>
          }
          //if book is there then change isCurrent and previous current book to be false
          //if book doesn't exist then add book info and isCurrent set to true
        }
      } else if (this.props.readUserBookPreference.allDataSets.length === 0) {
        allBookPref.splice(0, 0, bookSelected)
        //('create defaultUserBookPreference table')
        this.props.resultBookPref.updateBooks(allBookPref)
        this.props.resultBookPref.updateBook(bookSelected)
        this.props.resultBookPref.updateCreated()
        this.createDataSetUserBookPref(JSON.stringify(allBookPref))
      } else {
        return (
          <div>
            Error, please contact our support team [readUserBookPreference:{' '}
            {this.props.readUserBookPreference.allDataSets.length}]
          </div>
        )
      }
    } else {
      //('compare if seleted book exists')
      allBookPref = this.props.resultBookPref.books
      const bookSelectedBefore = allBookPref.filter(b => b.id === book.id)
      const bookPrevCurrent = allBookPref.filter(bo => bo.isCurrent === '1')
      if (bookSelectedBefore.length === 0) {
        //('book is not selected before')
        //remove current from previous current
        if (bookPrevCurrent.length === 1) {
          //('reset isCurrent')
          allBookPref[allBookPref.indexOf(bookPrevCurrent[0])]['isCurrent'] =
            '0'
        }
        allBookPref.splice(0, 0, bookSelected)
        //add new book as current
        this.props.resultBookPref.updateBooks(allBookPref)
        this.props.resultBookPref.updateBook(bookSelected)
        this.updateDataPointsUserBookPref(JSON.stringify(allBookPref))
      } else if (bookSelectedBefore.length === 1) {
        //('book is selected before')
        if (bookPrevCurrent.length === 1) {
          if (bookPrevCurrent[0].id === book.id) {
            this.props.history.goBack()
            return
          }
          allBookPref[allBookPref.indexOf(bookPrevCurrent[0])]['isCurrent'] =
            '0'
        }
        if (bookSelectedBefore[0].id === book.id) {
          allBookPref[allBookPref.indexOf(bookSelectedBefore[0])]['isCurrent'] =
            '1'
        }
        //add new book as current
        this.props.resultBookPref.updateBooks(allBookPref)
        this.props.resultBookPref.updateBook(bookSelected)
        this.updateDataPointsUserBookPref(JSON.stringify(allBookPref))
      } else {
        //('error: book is duplicated, contact support')
      }
    }
  }

  handleAddBook = () => {
    //('adding new book')
    const num =
      this.props.resultBooks.books.length === 0
        ? 1
        : this.props.resultBooks.books[0].id + 1
    const newBook = {
      id: num,
      bookName: '',
      bookAuthor: '',
      totalPages: 0,
      addedBy: global.localStorage.getItem(GC_USER_ID),
      addedAt: moment().format()
    }
    var allBooks = this.props.resultBooks.books
    allBooks.splice(0, 0, newBook)
    this.props.resultBooks.updateBooks(allBooks)
    this.props.resultBooks.updateBook(newBook)
    this.setState({ open: true })
  }

  handleCloseAddBookNo = () => {
    if (this.props.readBooksDefault.allDataSets.length === 1) {
      if (this.props.readBooksDefault.allDataSets[0].dataPoints !== '') {
        //('defualt book table is refreshed.')
        this.props.resultBooks.updateBooks(
          JSON.parse(this.props.readBooksDefault.allDataSets[0].dataPoints)
        )
      }
    }
    this.setState({ open: false })
  }

  handleCloseAddBookYes = () => {
    this.props.resultBooks.books[0] = this.props.resultBooks.book
    this.updateDataPoints(JSON.stringify(this.props.resultBooks.books))
    this.setState({ open: false })
  }

  handleCloseEditBook = () => {
    this.props.resultBooks.updateDataBySession()
    this.updateDataPoints(JSON.stringify(this.props.resultBooks.books))
    this.setState({ open: false })
  }

  handleSessionEdit = id => {
    this.props.resultBooks.updateSessionDataById(id)
    this.setState({
      open: true,
      isEdit: true
    })
  }

  handleSessionDelete = id => {
    this.props.resultBooks.deleteSessionById(id)
    //update to dataset
    if (this.props.resultBooks.books.length === 0) {
      this.updateDataPoints(JSON.stringify([]))
    } else {
      this.updateDataPoints(JSON.stringify(this.props.resultBooks.books))
    }
    this.setState({ open: false })
  }

  updateDataPoints = async dataPoints => {
    if (this.props.readBooksDefault.allDataSets.length === 0) {
      //('no default book data there')
      return
    }

    try {
      await this.props.UpdateDataSet({
        variables: {
          datasetId: this.props.readBooksDefault.allDataSets[0].id,
          dataPoints: dataPoints
        },
        update: () => {
          //('Book data updated')
        }
      })
    } catch (e) {
      console.log('There is an error: ' + e)
      // todo: add data refresher to re-read database and give to result store
      this.signOut()
    }
  }

  signOut = () => {
    global.localStorage.removeItem(GC_USER_ID)
    global.localStorage.removeItem(GC_AUTH_TOKEN)
    this.props.history.push(`/login`)
  }

  updateDataPointsUserBookPref = async dataPoints => {
    await this.props.UpdateDataSet({
      variables: {
        datasetId: this.props.readUserBookPreference.allDataSets[0].id,
        dataPoints: dataPoints
      },
      update: () => {
        //('Book data updated: readUserBookPreference')
        this.props.history.goBack()
      }
    })
  }

  createDataSet = async dataPoints => {
    const userId = global.localStorage.getItem(GC_USER_ID)
    if (!userId) {
      this.props.history.push(`/login`)
      return
    }
    // if default table is there, refuse to create
    if (this.props.readBooksDefault.allDataSets.length > 0) {
      //('there is already default book table there')
      return
    }

    await this.props.createDataSet({
      variables: {
        name: 'defaultBooks',
        description: 'defaultBooks',
        dataPoints: dataPoints,
        userId: userId
      },
      update: (store, { data: { createDataSet } }) => {
        //('default book table created')
      }
    })
  }

  createDataSetUserBookPref = async dataPoints => {
    const userId = global.localStorage.getItem(GC_USER_ID)
    if (!userId) {
      this.props.history.push(`/login`)
      return
    }
    // if default table is there, refuse to create
    if (this.props.readUserBookPreference.allDataSets.length > 0) {
      //('there is already default user book preference table there')
      return
    }

    await this.props.createDataSet({
      variables: {
        name: 'defaultUserBookPreference',
        description: 'defaultUserBookPreference',
        dataPoints: dataPoints,
        userId: userId
      },
      update: (store, { data: { createDataSet } }) => {
        //('default user book preference table created')
        this.props.resultBookPref.bookPrefDatasetId = createDataSet.id
        this.props.history.goBack()
      }
    })
  }

  handleClose = () => {
    this.props.history.push('/')
  }

  handleChange = name => event => {
    this.setState({
      [name]: event.target.value
    })
    this.props.resultBooks.book[name] = event.target.value
  }

  render() {
    const { classes } = this.props
    const userId = global.localStorage.getItem(GC_USER_ID)

    //todo: add user login redirect
    if (!userId) {
      this.props.history.push(`/login`)
    }

    if (this.props.readBooksDefault.loading) {
      return <div>Loading book data ... </div>
    }

    if (this.props.readBooksDefault && this.props.readBooksDefault.error) {
      return <div>Error</div>
    }

    if (
      this.props.resultBooks.books.length === 0 &&
      !this.props.resultBooks.created
    ) {
      if (this.props.readBooksDefault.allDataSets.length === 1) {
        if (this.props.readBooksDefault.allDataSets[0].dataPoints !== '') {
          //('defualt book table is there.')
          this.props.resultBooks.updateBooks(
            JSON.parse(this.props.readBooksDefault.allDataSets[0].dataPoints)
          )
        }
      } else if (this.props.readBooksDefault.allDataSets.length === 0) {
        //('defualt book table to be added')
        this.createDataSet(JSON.stringify(this.props.resultBooks.books))
        this.props.resultBooks.updateCreated()
      } else {
        return (
          <div>
            Error, please contact our support team [readBooksDefault:{' '}
            {this.props.readBooksDefault.allDataSets.length}]
          </div>
        )
      }
    }

    //get current books based on selected filter
    const booksReading = this.props.resultBookPref.books.filter(
      b =>
        parseInt(b.maxPage, 10) > 0 &&
        parseInt(b.maxPage, 10) < parseInt(b.totalPages, 10)
    )
    const booksCompleted = this.props.resultBookPref.books.filter(
      b =>
        parseInt(b.totalPages, 10) > 0 &&
        parseInt(b.maxPage, 10) >= parseInt(b.totalPages, 10)
    )
    const booksToReadTmp = this.props.resultBookPref.books.filter(
      b => parseInt(b.maxPage, 10) > 0
    )

    var booksToRead = []
    this.props.resultBooks.books.forEach(b => {
      var flag = false
      booksToReadTmp.forEach(e => {
        if (b.id === e.id) {
          flag = true
        }
      })
      if (!flag) {
        booksToRead.push(b)
      }
    })

    const bookData =
      this.state.bookTypeSelected === 'Reading'
        ? booksReading
        : this.state.bookTypeSelected === 'Completed'
          ? booksCompleted
          : booksToRead

    return (
      <div className={classes.root}>
        <Paper
          style={{
            width: '100%',
            height: '100%',
            backgroundColor: 'white',
            textAlign: 'center'
          }}
        >
          <List>
            <ListItem divider>
              <IconButton
                color="inherit"
                aria-label="Back"
                onClick={this.handleClose}
              >
                <ChevronLeftIcon />
              </IconButton>
              <ListItemText
                className={classes.modalHealder}
                primary={
                  <Typography
                    variant="body1"
                    style={{ fontSize: 18, color: 'grey' }}
                  >
                    What book would you like to read?
                  </Typography>
                }
              />
            </ListItem>
            <ListItem>
              <div className={classes.divText}>
                <Typography
                  onClick={() => this.handleFilterChange('To Read')}
                  variant="caption"
                  className={
                    this.state.bookTypeSelected === 'To Read'
                      ? classes.textFilter
                      : classes.textFilterGery
                  }
                >
                  Add To Read
                </Typography>
                <Typography
                  onClick={() => this.handleFilterChange('Reading')}
                  variant="caption"
                  className={
                    this.state.bookTypeSelected === 'Reading'
                      ? classes.textFilter
                      : classes.textFilterGery
                  }
                >
                  Reading
                </Typography>
                <Typography
                  onClick={() => this.handleFilterChange('Completed')}
                  variant="caption"
                  className={
                    this.state.bookTypeSelected === 'Completed'
                      ? classes.textFilter
                      : classes.textFilterGery
                  }
                >
                  Completed
                </Typography>
              </div>
            </ListItem>
            <ListItem className={classes.activeSection}>
              <GridList className={classes.gridList} cols={3}>
                <GridListTile xs={6} cols={1} key={'addnew'}>
                  {this.state.bookTypeSelected === 'To Read' ? (
                    <Paper
                      className={classes.paperBlockAdd}
                      onClick={this.handleAddBook}
                    >
                      <div id="bookblock" className={classes.bookBlock}>
                        <AddIcon className={classes.iconBookAdd} />
                        <Typography
                          variant="body1"
                          id="bookName"
                          style={{
                            paddingLeft: 8,
                            paddingRight: 8,
                            paddingTop: 6,
                            textAlign: 'center'
                          }}
                        >
                          Add Book
                        </Typography>
                      </div>
                    </Paper>
                  ) : this.state.bookTypeSelected === 'Reading' ? (
                    <Paper className={classes.paperBlockAddNoCursor}>
                      <div id="bookblock" className={classes.bookBlock}>
                        <Typography
                          variant="body1"
                          id="bookName"
                          style={{
                            paddingLeft: 8,
                            paddingRight: 8,
                            paddingTop: 6,
                            textAlign: 'center',
                            color: 'lightgrey'
                          }}
                        >
                          {bookData.length === 0
                            ? "You haven't started any books yet ..."
                            : 'Pick one and finish it ⇢'}
                        </Typography>
                      </div>
                    </Paper>
                  ) : this.state.bookTypeSelected === 'Completed' ? (
                    <Paper className={classes.paperBlockAddNoCursor}>
                      <div id="bookblock" className={classes.bookBlock}>
                        <Typography
                          variant="body1"
                          id="bookName"
                          style={{
                            paddingLeft: 8,
                            paddingRight: 8,
                            paddingTop: 6,
                            textAlign: 'center',
                            color: 'lightgrey'
                          }}
                        >
                          {bookData.length === 0
                            ? "You haven't completed any books yet ..."
                            : 'Re-read a completed book ⇢'}
                        </Typography>
                      </div>
                    </Paper>
                  ) : (
                    ''
                  )}
                </GridListTile>
                {bookData.map(bk => (
                  <GridListTile xs={6} cols={1} key={bk.id}>
                    <Paper
                      className={classes.paperBlock}
                      onClick={() => this.chooseBook(bk)}
                    >
                      <div id="bookblock" className={classes.bookBlock}>
                        <ImportContactsIcon className={classes.iconBook} />
                        <Typography
                          variant="body1"
                          id="bookName"
                          style={{
                            paddingLeft: 8,
                            paddingRight: 2,
                            textAlign: 'left',
                            fontSize: 12
                          }}
                        >
                          {bk.bookName}
                        </Typography>
                        <Typography
                          variant="caption"
                          id="bookAuthor"
                          style={{
                            paddingLeft: 8,
                            paddingRight: 8,
                            fontSize: 9,
                            textAlign: 'left'
                          }}
                        >
                          {bk.bookAuthor}
                        </Typography>
                      </div>
                    </Paper>
                    <div className={classes.divAddModalButton}>
                      {parseInt(bk.maxPage, 10) > 0 &&
                        parseInt(bk.totalPages, 10) > 0 && (
                          <div className={classes.progressBar}>
                            {parseInt(bk.maxPage, 10) *
                              100 /
                              parseInt(bk.totalPages, 10) <
                            100 ? (
                              <span
                                style={{ fontSize: 10, color: 'lightgrey' }}
                              >
                                {(
                                  parseInt(bk.maxPage, 10) *
                                  100 /
                                  parseInt(bk.totalPages, 10)
                                ).toFixed(0)}%
                              </span>
                            ) : (
                              <CheckIcon
                                style={{ color: 'lightgreen', fontSize: 12 }}
                              />
                            )}
                            <LinearProgress
                              variant="determinate"
                              value={
                                parseInt(bk.maxPage, 10) *
                                100 /
                                parseInt(bk.totalPages, 10)
                              }
                              classes={{
                                colorPrimary: classes.linearColorPrimary,
                                barColorPrimary:
                                  parseInt(bk.maxPage, 10) *
                                    100 /
                                    parseInt(bk.totalPages, 10) >=
                                  100
                                    ? classes.linearBarColorPrimaryComplete
                                    : classes.linearBarColorPrimary
                              }}
                            />
                          </div>
                        )}
                      <IconButton
                        className={classes.iconBtnCheckAdd}
                        onClick={() => this.handleSessionEdit(bk.id)}
                      >
                        <EditIcon className={classes.iconEdit} />
                      </IconButton>
                    </div>
                  </GridListTile>
                ))}
              </GridList>
            </ListItem>
            <ListItem>
              <ListItemText />
              <Button color="inherit" onClick={this.handleClose}>
                <Typography
                  variant="body1"
                  style={{ fontSize: 18, color: 'grey' }}
                >
                  Back
                </Typography>
              </Button>
            </ListItem>
            <ListItem className={classes.addSection} />
          </List>
        </Paper>
        <Modal
          aria-labelledby="simple-modal-title"
          aria-describedby="simple-modal-description"
          open={this.state.open}
          onClose={this.handleCloseAddBookNo}
          className={classes.modalAddToday}
          disableBackdropClick
          disableAutoFocus
        >
          <Paper className={classes.paperAddTodayMoreInfo}>
            <div id="clearBtnBedTime" className={classes.divAddTpday}>
              <div className={classes.divClearButton}>
                <IconButton
                  className="btn btn-default btn-style"
                  onClick={this.handleCloseAddBookNo}
                >
                  <ClearIcon className={classes.iconClear} />
                </IconButton>
              </div>
              <List>
                <ListItem divider>
                  <ListItemText
                    className={classes.modalHealder}
                    primary={'Add Book Information'}
                  />
                </ListItem>
                <ListItem className={classes.modalContent}>
                  <ListItemIcon>
                    <BookIcon className={classes.editIcons} />
                  </ListItemIcon>
                  <TextField
                    id="bookName"
                    label="Book Name"
                    className={classes.textField}
                    value={this.props.resultBooks.book.bookName}
                    onChange={this.handleChange('bookName')}
                    margin="normal"
                  />
                </ListItem>
                <ListItem className={classes.modalContentWhite}>
                  <ListItemIcon>
                    <BookIcon className={classes.editIcons} />
                  </ListItemIcon>
                  <TextField
                    id="bookAuthor"
                    label="Author"
                    className={classes.textField}
                    value={this.props.resultBooks.book.bookAuthor}
                    onChange={this.handleChange('bookAuthor')}
                    margin="normal"
                  />
                </ListItem>
                <ListItem className={classes.modalContent}>
                  <ListItemIcon>
                    <DescriptionIcon className={classes.editIcons} />
                  </ListItemIcon>
                  <TextField
                    id="totalPages"
                    label="Total Pages"
                    className={classes.textField}
                    value={this.props.resultBooks.book.totalPages}
                    onChange={this.handleChange('totalPages')}
                    margin="normal"
                  />
                </ListItem>
                {this.state.isEdit ? (
                  <ListItem className={classes.modalContentDone}>
                    <Button
                      color="inherit"
                      onClick={() =>
                        this.handleSessionDelete(this.props.resultBooks.book.id)
                      }
                      className={classes.iconBtnCheck}
                    >
                      <Typography
                        variant="body1"
                        style={{ fontSize: 18, color: 'grey' }}
                      >
                        Delete
                      </Typography>
                    </Button>
                    <ListItemText />
                    <Button
                      color="inherit"
                      onClick={this.handleCloseEditBook}
                      className={classes.iconBtnCheck}
                    >
                      <Typography
                        variant="body1"
                        style={{ fontSize: 18, color: 'grey' }}
                      >
                        Done
                      </Typography>
                    </Button>
                  </ListItem>
                ) : (
                  <ListItem className={classes.modalContentDone}>
                    <ListItemText />
                    <Button
                      color="inherit"
                      onClick={this.handleCloseAddBookYes}
                      className={classes.iconBtnCheck}
                    >
                      <Typography
                        variant="body1"
                        style={{ fontSize: 18, color: 'grey' }}
                      >
                        Add
                      </Typography>
                    </Button>
                  </ListItem>
                )}
              </List>
            </div>
          </Paper>
        </Modal>
      </div>
    )
  }
}

AlchemyBooks.propTypes = {
  classes: PropTypes.object
}

AlchemyBooks.defaultProps = {
  classes: {}
}



// WEBPACK FOOTER //
// ./src/routes/alchemy/books.js